import {addPrefixToObjectKeys} from '../../../helpers/Utils';
import main from './en/main.json';
import admSection from './en/admSection.json';
import admSuperSection from './en/admSuperSection.json';
import admGroup from './en/admGroup.json';
import admInfirmary from './en/admInfirmary.json';
import admLocalization from './en/admLocalization.json';
import admPublication from './en/admPublication.json';
import admAssignment from './en/admAssignment.json';
import admJustification from './en/admJustification.json';
import admAttendance from './en/admAttendance.json';
import admUser from './en/admUser.json';
import admStudent from './en/admStudent.json';
import admModule from './en/admModule.json';
import admCommunications from './en/admCommunications.json';
import admCalendar from './en/admCalendar.json';
import admNotification from './en/admNotification.json';
import admFlow from './en/admFlow.json';
import admFlowInput from './en/admFlowInput.json';
import admPeriod from './en/admPeriod.json';
import admActivity from './en/admActivity.json';
import admRegist from './en/admRegist.json';

const m = addPrefixToObjectKeys(main, "main.");
const section = addPrefixToObjectKeys(admSection, "admSection.");
const superSection = addPrefixToObjectKeys(admSuperSection, "admSuperSection.");
const group = addPrefixToObjectKeys(admGroup, "admGroup.");
const infirmary = addPrefixToObjectKeys(admInfirmary, "admInfirmary.");
const localization = addPrefixToObjectKeys(admLocalization, "admLocalization.");
const publication = addPrefixToObjectKeys(admPublication, "admPublication.");
const assignment = addPrefixToObjectKeys(admAssignment, "admAssignment.");
const justification = addPrefixToObjectKeys(admJustification, "admJustification.");
const attendance = addPrefixToObjectKeys(admAttendance, "admAttendance.");
const user = addPrefixToObjectKeys(admUser, "admUser.");
const student = addPrefixToObjectKeys(admStudent, "admStudent.");
const modules = addPrefixToObjectKeys(admModule, "admModule.");
const communications = addPrefixToObjectKeys(admCommunications, "admCommunications.");
const calendar = addPrefixToObjectKeys(admCalendar, "admCalendar.");
const notification = addPrefixToObjectKeys(admNotification, "admNotification.");
const flow = addPrefixToObjectKeys(admFlow, "admFlow.");
const flowInput = addPrefixToObjectKeys(admFlowInput, "admFlowInput.");
const period = addPrefixToObjectKeys(admPeriod, "admPeriod.");
const activity = addPrefixToObjectKeys(admActivity, "admActivity.");
const regist = addPrefixToObjectKeys(admRegist, "admRegist.");

const r = {
  ...m, ...group, ...infirmary, ...publication, ...localization, ...assignment, ...section, ...superSection,
  ...justification, ...attendance, ...user, ...student, ...modules, ...communications, ...calendar, ...notification, ...flow, ...flowInput, ...period,
  ...activity, ...regist
}
export default r;
